"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRatingColor = exports.getRatingLabel = exports.runNTimesReturn = void 0;

var _const = require("./const");

var runNTimesReturn = function runNTimesReturn(n, func) {
  var arr = [];

  for (var i = 1; i <= n; i += 1) {
    arr.push(func(i));
  }

  return arr;
};

exports.runNTimesReturn = runNTimesReturn;

var getRatingLabel = function getRatingLabel(rating) {
  if (Number.isNaN(rating)) {
    return null;
  }

  switch (rating) {
    case 1:
    case 2:
    case 3:
      return _const.SkillExpertiseEnum.beginner;

    case 4:
    case 5:
    case 6:
    case 7:
      return _const.SkillExpertiseEnum.intermediate;

    case 8:
    case 9:
    case 10:
      return _const.SkillExpertiseEnum.expert;

    default:
      return _const.SkillExpertiseEnum.beginner;
  }
};

exports.getRatingLabel = getRatingLabel;

var getRatingColor = function getRatingColor(rating) {
  var ratingLabel = getRatingLabel(rating);
  if (ratingLabel === _const.SkillExpertiseEnum.beginner) return 'yellowHover';
  if (ratingLabel === _const.SkillExpertiseEnum.intermediate) return 'accentHover';
  if (ratingLabel === _const.SkillExpertiseEnum.expert) return 'greenHover';
  return 'grey3';
};

exports.getRatingColor = getRatingColor;